import { render, staticRenderFns } from "./NavInfo.vue?vue&type=template&id=129c6779&scoped=true&"
import script from "./NavInfo.vue?vue&type=script&lang=js&"
export * from "./NavInfo.vue?vue&type=script&lang=js&"
import style0 from "./NavInfo.vue?vue&type=style&index=0&id=129c6779&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c6779",
  null
  
)

export default component.exports